// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__HsSBF","info":"Note_info__dtA2r","note":"Note_note__1mTKF","actions":"Note_actions__IHJ4w"};